import { visuallyHiddenStyles } from "@newsela/angelou";
import PropTypes from "prop-types";

import useAnnotationsState from "@/view/utils/useAnnotationsState";
import wordSplittingRegEx from "@/view/utils/wordSplittingRegEx";
import { annotationPropType } from "@/view/viewPropTypes";
import { anchorCss } from "./ContentBodyAnnotatedTextAnchor.style";

const propTypes = {
  annotation: annotationPropType,
  text: PropTypes.string,
};

const ContentBodyAnnotationAnchor = ({ annotation, text }) => {
  const {
    annotationHighlightsState,
    contentBodyAnnotationRefs,
    focusAnnotationCard,
    setAnnotationHighlightsState,
  } = useAnnotationsState();

  if (!text) return;

  const textWords = text.match(wordSplittingRegEx);
  // The first three words of the annotation are used to label it for screen readers.
  const startingWords = textWords?.slice(0, 3);
  const beginningText = startingWords?.join("").trim();

  return (
    <a
      aria-label={`Annotation start, text beginning ${beginningText}`}
      href="#"
      onClick={(e) => {
        e.preventDefault();
        focusAnnotationCard(annotation.id);
      }}
      css={[visuallyHiddenStyles, anchorCss]}
      data-annotation-id={annotation.id}
      onFocus={() =>
        setAnnotationHighlightsState({
          ...annotationHighlightsState,
          focus: annotation.id,
        })
      }
      onBlur={() =>
        setAnnotationHighlightsState({
          ...annotationHighlightsState,
          focus: null,
        })
      }
      ref={(ref) => {
        if (ref) {
          contentBodyAnnotationRefs.current[annotation.id] = ref;
        }
      }}
    />
  );
};

ContentBodyAnnotationAnchor.propTypes = propTypes;

export default ContentBodyAnnotationAnchor;
